@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row && $.row.tsk_type) {
    <span> {{ getEnumKeyByEnumValue($.row.tsk_type) }}</span>
  } @else {
    -
  }
}
